//文字コードはutf-8

function finishAnimation(details, callback) {
    var onTransitionEnd = function (event) {
        if (event.propertyName !== 'height') return;

        details.removeEventListener('transitionend', onTransitionEnd);
        details.classList.remove('is-animating');

        if (callback) callback();

        details.removeAttribute('style');
        delete details.dataset.animating;
    };

    details.addEventListener('transitionend', onTransitionEnd);
}

function openDetails(details) {
    var startHeight = details.offsetHeight;

    details.open = true;
    details.dataset.animating = 'true';
    details.classList.add('is-animating');
    details.style.height = startHeight + 'px';

    requestAnimationFrame(function () {
        details.classList.add('is-open');
        details.style.height = details.scrollHeight + 'px';
    });

    finishAnimation(details);
}

function closeDetails(details, summary) {
    var startHeight = details.offsetHeight;
    var endHeight = summary.offsetHeight;

    details.dataset.animating = 'true';
    details.classList.add('is-animating', 'is-closing');
    details.style.height = startHeight + 'px';

    requestAnimationFrame(function () {
        details.classList.remove('is-open');
        details.style.height = endHeight + 'px';
    });

    finishAnimation(details, function () {
        details.open = false;
        details.classList.remove('is-closing');
    });
}

export function initFAQ() {
    var accordions = document.querySelectorAll('.jsFAQAccordion');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!accordions.length) return;

    accordions.forEach(function (details) {
        var summary = details.querySelector('summary');

        if (!summary) return;

        details.classList.toggle('is-open', details.open);

        summary.addEventListener('click', function (event) {
            if (reduceMotion) {
                requestAnimationFrame(function () {
                    details.classList.toggle('is-open', details.open);
                });
                return;
            }

            event.preventDefault();

            if (details.dataset.animating === 'true') return;

            if (details.open) {
                closeDetails(details, summary);
            } else {
                openDetails(details);
            }
        });
    });
}
